// **********************************************************************
//
// Copyright (c) 2003-2017 ZeroC, Inc. All rights reserved.
//
// This copy of Ice is licensed to you under the terms described in the
// ICE_LICENSE file included in this distribution.
//
// **********************************************************************
//
// Ice version 3.7.0
//
// <auto-generated>
//
// Generated from file `SliceChecksumDict.ice'
//
// Warning: do not edit this file.
//
// </auto-generated>
//

/* slice2js browser-bundle-skip */
// (function(module, require, exports)
// {
/* slice2js browser-bundle-skip-end */
/* slice2js browser-bundle-skip */
    const _ModuleRegistry = require("../Ice/ModuleRegistry").Ice._ModuleRegistry;
    const Ice = 
    (
        require("../Ice/Long"),
        require("../Ice/HashMap"),
        require("../Ice/HashUtil"),
        require("../Ice/ArrayUtil"),
        require("../Ice/StreamHelpers")
    ).Ice;

    const Slice = Ice.Slice;
/* slice2js browser-bundle-skip-end */

    Slice.defineDictionary(Ice, "SliceChecksumDict", "SliceChecksumDictHelper", "Ice.StringHelper", "Ice.StringHelper", false, undefined, undefined);
/* slice2js browser-bundle-skip */
    exports.Ice = Ice;
/* slice2js browser-bundle-skip-end */
/* slice2js browser-bundle-skip */
// }
// (typeof(global) !== "undefined" && typeof(global.process) !== "undefined" ? module : undefined,
//  typeof(global) !== "undefined" && typeof(global.process) !== "undefined" ? require : this.Ice._require,
//  typeof(global) !== "undefined" && typeof(global.process) !== "undefined" ? exports : this));
/* slice2js browser-bundle-skip-end */



//////////////////
// WEBPACK FOOTER
// ./~/ice/src/Ice/SliceChecksumDict.js
// module id = 454
// module chunks = 0